import {
  BoardTheme,
  PieceId,
  PieceIds,
  VariantType,
} from "../@types/app.types";
import { BoardGridTheme } from "../components/Board/Board";
import {
  BoardHeaderFooterElement,
  makePieceSetDesignConfig,
} from "../contexts/studio/studioDesign.contextPartial";
import { MSG } from "../lang/MSG.enum";
import { ColorPalette } from "../utils/colors.utils";

const BoardThemeGenwanWarm: BoardTheme = {
  identifier: "genwan-warm",
  name: MSG.themeNameGenwanWarm,
  value: {
    board: {
      backgroundColor: ColorPalette.ivory,
      borderWidth: 1,
      borderRadius: 0,
      textColor: ColorPalette.inkBlue,
      borderColor: ColorPalette.ivory,
      fontSize: 48,
      fontFamily: "genwan",
      fontWeight: 600,
      inset: {
        userDefined: {
          top: 50,
          left: 50,
          right: 50,
          bottom: 150,
        },
      },
    },
    header: {
      distanceToBoardContent: 30,
      middle: {
        element: BoardHeaderFooterElement.None,
      },
    },
    footer: {
      distanceToBoardContent: 62,
      middle: {
        element: BoardHeaderFooterElement.LogoPZ,
      },
    },
    grid: {
      theme: "default" as BoardGridTheme,
      color: ColorPalette.inkBlue,
      opacity: 0.62,
    },
    columnNumberLabels: {
      enabled: true,
      red: {
        fontSize: 36,
        fontWeight: 600,
      },
      black: {
        fontSize: 36,
        fontWeight: 500,
      },
    },
    pieceSet: {
      charSet: "Genwan",
      charSetVariantDefs: {} as Record<PieceId, VariantType>,
    },
    red: makePieceSetDesignConfig("red"),
    black: makePieceSetDesignConfig("black"),
    debugMarker: {
      size: 68,
    },
  },
};

[...PieceIds].forEach(
  i =>
    (BoardThemeGenwanWarm.value.pieceSet!.charSetVariantDefs![i as PieceId] =
      "A")
);

export default BoardThemeGenwanWarm;
